<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4>Users</h4>
                <p>Description of users.</p>
                <DataTable :value="users" :paginator="true" :rows="10" dataKey="email" :filters="filters" :loading="loading"
                    class="user_table" sortField="email" :sortOrder="1">
                    <template #header>
                        <div class="p-d-md-flex p-jc-md-between">
                            Users
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Search Users" />
                            </span>
                        </div>
                    </template>
                    <template #empty>
                        No users found.
                    </template>
                    <template #loading>
                        Loading activity data. Please wait.
                    </template>
                    <Column field="active" header="Active" headerStyle="width: 6rem; text-align: left"
                        bodyStyle="text-align: left; overflow: visible">
                        <template #body="slotProps">
                            <InputSwitch v-model="slotProps.data.active" @change="updateUser(slotProps.data.id)"
                                v-if="((user.data.role.permissionLevel >= 10 && (user.data.id != slotProps.data.id)) || ((user.data.role.permissionLevel >= 6)) && (user.data.client.key == slotProps.data.client.key) && (user.data.role.permissionLevel >= slotProps.data.role.permissionLevel) && (user.data.id != slotProps.data.id))" />
                            <InputSwitch v-model="slotProps.data.active" disabled v-else />
                        </template>
                    </Column>
                    <Column field="email" header="Email" :sortable="true">
                        <template #body="slotProps">
                            <div class="user_email">
                                {{ slotProps.data.email }}
                            </div>
                        </template>
                    </Column>
                    <Column field="role" header="User Level">
                        <template #body="slotProps">
                            <Dropdown @show="updateUserLevelOrder()"
                                v-if="((user.data.role.permissionLevel >= 6) && (slotProps.data.role.permissionLevel <= user.data.role.permissionLevel)) || (slotProps.data.role.permissionLevel == null)"
                                v-model="slotProps.data.role" :options="newOrder" optionLabel="name"
                                :placeholder="slotProps.data.role.name ? slotProps.data.role.name : 'Select Role'"
                                @change="updateUser(slotProps.data.id)" />
                            <div v-else>
                                {{ slotProps.data.role.name }}
                            </div>
                        </template>
                    </Column>
                    <Column field="clients" header="User Company">
                        <template #body="slotProps">
                            <span v-if="slotProps.data.role.permissionLevel == 10"></span>
                            <span v-else>
                                <!-- Super Admin Only -->
                                <Dropdown v-if="(user.data.role.permissionLevel >= 10)" v-model="slotProps.data.client"
                                    :options="clients" optionLabel="name"
                                    :placeholder="slotProps.data.client ? slotProps.data.client.name : 'Select Company'"
                                    :filter="true" @change="updateUser(slotProps.data.id)" />
                                <div v-else>
                                    <span v-if="slotProps.data.client.name">{{ slotProps.data.client.name }}</span>
                                    <span v-else>None</span>
                                </div>
                            </span>
                        </template>
                    </Column>
                    <!-- Column referring to diolog box -->
                    <Column field="Permissions" header="Edit Permissions" headerStyle="width: 13rem;"
                        bodyStyle="text-align: right; overflow: visible">
                        <template #body="slotProps">
                            <!-- Company Admins / Super Admins only -->
                            <span v-if="slotProps.data.role.permissionLevel >= 8"></span>
                            <span v-else>
                                <Button label="Edit Permissions" icon="pi pi-pencil" v-if="((user.data.role.permissionLevel >= 8) && (slotProps.data.role.permissionLevel <= user.data.role.permissionLevel) && (slotProps.data.client.key == user.data.client.key))
                                    || ((user.data.role.permissionLevel >= 10))"
                                    @click.prevent="(displayPermissions = true, addPermissionsForDialog(slotProps))"></Button>
                                <Button v-else label="Edit Permissions" icon="pi pi-pencil" disabled></Button>
                            </span>
                        </template>
                    </Column>
                    <Column field="delete" header="" headerStyle="width: 5rem; text-align: center"
                        bodyStyle="text-align: right; overflow: visible">
                        <template #body="slotProps">
                            <Button icon="pi pi-trash"
                                @click="deleteUserConfirmation = true, toggleDeleteDialog(slotProps.data.id)"
                                class="p-button p-button-danger"
                                v-if="(user.data.role.permissionLevel >= 8 && (slotProps.data.role.permissionLevel < user.data.role.permissionLevel && user.data.id != slotProps.data.id))" />
                        </template>
                    </Column>
                </DataTable>

                <!-- User Deletion Confirmation dialog box -->
                <Dialog header="Delete User?" :visible.sync="deleteUserConfirmation" :style="{ width: '350px' }"
                    :modal="true" @hide="toggleDeleteDialog()">
                    <div class="confirmation-content">
                        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" /><br>
                        <span>Are you sure you want to delete this user? <br> All data will be lost.</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" @click="deleteUserConfirmation = false, toggleDeleteDialog()"
                            class="p-button-text" />
                        <Button label="Yes" icon="pi pi-check" @click="deleteUserConfirmation = false, removeUser(deleteId)"
                            class="p-button-text" autofocus />
                    </template>
                </Dialog>

                <!-- Permissions/Site Access dialog box -->
                <Dialog :header="('Permissions: ' + user_permissions.email)" :visible.sync="displayPermissions"
                    :modal="true"
                    @hide="displayPermissions = false, updatePermissionsForDialog(), siteLoading = true, resetSiteFilter()"
                    >
                    <DataTable :value="clientSites" :paginator="true" :rows="10" dataKey="name" :filters="siteFilters"
                        :loading="siteLoading" class="site_table" sortField="name" :sortOrder="1">
                        <template #header>
                            <div class="p-d-flex p-jc-between p-ai-baseline">
                                {{ user_permissions.client }}
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search" />
                                    <InputText v-model="siteFilters['global'].value" placeholder="Search Sites" />
                                </span>
                            </div>
                        </template>
                        <template #empty>
                            No Sites found.
                        </template>
                        <template #loading>
                            Loading Site data. Please wait.
                        </template>
                        <Column field="name" :sortable="true" header="Sites">
                            <template #body="slotProps">
                                <div class="site_list_item">
                                    <Checkbox :name="slotProps.data.name" :value="slotProps.data.key" v-model="checkboxes"
                                        @change="addCheckboxItemToArray(user_permissions)">
                                    </Checkbox>
                                    <label :for="slotProps.data.name">{{ slotProps.data.name }}</label>
                                </div>
                            </template>
                        </Column>
                    </DataTable>

                    <Button label="Done" class="p-mt-3"
                        @click.prevent="(displayPermissions = false, updateUser(user_permissions.id))"></Button>

                    <Button v-if="user_permissions.permissionLevel <= 2" label="Edit Asset Batches" class="p-mt-3 p-ml-3"
                        @click.prevent="(displayPermissions = false, updateUser(user_permissions.id), displayAssetBatches = true, addAssetBatchesForDialog(user_permissions))"></Button>
                </Dialog>

                <!-- Asset Batches dialog box -->
                <Dialog :header="('Asset Batches: ' + user_permissions.email)" :visible.sync="displayAssetBatches"
                    :modal="true"
                    @hide="displayAssetBatches = false, updatePermissionsForDialog(), siteLoading = true"
                    :style="{ width: '40rem' }">
                    <DataTable :value="userBatches" responsiveLayout="scroll">
                        <template #empty>
                            No Batches found.
                        </template>
                        <template #loading>
                            Loading Batch data. Please wait.
                        </template>
                        <Column field="site_checkbox">
                            <template #body="slotProps">
                                <Checkbox :name="slotProps.data.site_name" :value="slotProps.data.key"
                                    v-model="userBatchesCheckboxes"
                                    @change="addAssetBatchCheckboxItemToArray(user_permissions)">
                                </Checkbox>
                            </template>
                        </Column>
                        <Column field="site_id" header="Site">
                            <template #body="slotProps">
                                {{ slotProps.data.site_name }}
                            </template>
                        </Column>
                        <Column field="from_id" header="From">
                            <template #body="slotProps">
                                {{ slotProps.data.from_id }}
                            </template>
                        </Column>
                        <Column field="to_id" header="To">
                            <template #body="slotProps">
                                {{ slotProps.data.to_id }}
                            </template>
                        </Column>
                    </DataTable>

                    <Button label="Done" class="p-mt-3"
                        @click.prevent="(displayAssetBatches = false, updateUser(user_permissions.id), updateAssetBatchesForDialog())"></Button>
                </Dialog>

                <div class="p-d-flex p-jc-end">
                    <Button label="New User" icon="pi pi-plus" class="p-button-secondary p-mt-3"
                        @click="generate(), visibleRight = true, updateUserLevelOrder()" iconPos="right"
                        v-if="(user.data.role.permissionLevel >= 8)" />
                    <Sidebar :visible.sync="visibleRight" :baseZIndex="1000" position="right"
                        v-if="(user.data.role.permissionLevel >= 8)">
                        <h1 style="fontWeight:normal">Add User</h1>

                        <ValidationObserver v-slot="{ handleSubmit }" slim ref="info">
                            <form @submit.prevent="addUser">
                                <ValidationProvider name="email" rules="email" v-slot="{ errors }">
                                    <div class="p-float-label p-my-5">
                                        <InputText id="email" type="email" v-model="selected.email" />
                                        <label for="email">User Email</label>
                                        <span class="error">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                                <div class="p-float-label p-my-5">
                                    <Dropdown v-model="selected.role" :options="newOrder" optionLabel="name" />
                                    <label for="role">User Level</label>
                                </div>
                                <div class="p-float-label p-my-5" v-if="(user.data.role.permissionLevel >= 10)">
                                    <Dropdown v-model="selected.client" :options="clients" optionLabel="name" />
                                    <label for="client">User Company</label>
                                </div>
                                <ValidationProvider name="password" rules="min:6" v-slot="{ errors }">
                                    <div class="p-float-label p-my-5">
                                        <InputText id="password" type="text" v-model="selected.password" />
                                        <label for="password">User Password</label>
                                        <span class="error">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                                <Button type="submit" label="Save" class="p-button-success" style="margin-right:.25em" />
                                <Button type="button" @click="visibleRight = false, clearUserLevelOrder()" label="Cancel"
                                    class="p-button-secondary" />
                            </form>
                        </ValidationObserver>

                    </Sidebar>
                </div>
                <Toast />
            </div>
        </div>
    </div>
</template>

<script>
import { auth, db } from '@/firebase';
import {deleteUser} from "firebase/compat/auth";
import axios from 'axios';
import { mapGetters } from "vuex";
import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';
import { FilterMatchMode } from 'primevue/api';


extend('min', {
    ...min,
    message: (fieldName) => {
        return `Password must be at least 6 characters long.`;
    }
});



extend('email', {
    ...email,
    message: (fieldName) => {
        return `Please enter an email address`;
    }
});

export default {
    data() {
        return {
            filters: { global: { value: null, matchMode: FilterMatchMode.CONTAINS } },
            siteFilters: { global: { value: null, matchMode: FilterMatchMode.CONTAINS } },
            checkboxes: [],
            userBatchesCheckboxes: [],
            loading: true,
            siteLoading: true,
            expandedRows: [],
            password: {
                size: 10,
                characters: 'a-z,A-Z,0-9,#',
            },
            selected: {
                email: '',
                role: '',
                password: '',
                client: ''
            },
            clients: [],
            users: [],
            user_permissions: {
                key: '',
                email: '',
                client: '',
                client_id: '',
                assigned_sites: '',
                assigned_batches: []
            },
            delete_user_data: {
                key: '',
                email: '',
                client: '',
                client_id: '',
                assigned_sites: '',
                assigned_batches: []
            },
            clientSites: [],
            userBatches: [],
            assetBatchSites: [],
            user_levels: [],
            newOrder: [],
            userData: [],
            visibleRight: false,
            displayPermissions: false,
            displayAssetBatches: false,
            deleteUserConfirmation: false,
            deleteId: ''
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    firestore() {
        const userPerms = this.user.data.role.permissionLevel,
            storeUserId = this.$store.getters.user.data.client.key;

            console.log(this.$store.getters.user.data.client.key)

        if (userPerms >= 10) {
            // super admin only
            return {
                clients: db.collection('clients'),
                user_levels: db.collection('user_levels'),
                // clientSites: db.collection('sites'),
                users: {
                    ref: db.collection('users'),
                    resolve: (data) => {
                        this.loading = false;
                    }
                }
            }
        }
        else if (userPerms >= 6 && userPerms < 10) {
            // company admin and site manager permission level
            return {
                clients: db.collection('clients'),
                user_levels: db.collection('user_levels'),
                // clientSites: db.collection('sites'),
                users: {
                    ref: db.collection('users').where('client.key', '==', storeUserId),
                    resolve: (data) => {
                        this.loading = false
                    }
                }
            }
        }
        else {
            return {
                clients: db.collection('clients'),
                user_levels: db.collection('user_levels'),
                // clientSites: db.collection('sites'),
                users: {
                    ref: db.collection('users').where('client.key', '==', storeUserId),
                    resolve: (data) => {
                        this.loading = false
                    }
                }
            }
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        })
    },
    methods: {
        updateUserLevelOrder() {
            // reorder user levels to highest permission down
            const storeUserPerms = this.$store.getters.user.data.role.permissionLevel;
            const initOrder = this.user_levels;
            this.newOrder = [];

            initOrder.forEach(level => {
                // removes user levels that are higher than the current users level
                if (level.permissionLevel <= storeUserPerms) {
                    this.newOrder.push(level);
                }
            });

            // sorts the array descending
            this.newOrder.sort((a, b) => a.permissionLevel - b.permissionLevel);
            this.newOrder.reverse();
        },
        clearUserLevelOrder() {
            this.newOrder = [];
        },
        addPermissionsForDialog(slotPropsData) {
            this.user_permissions = {};
            this.user_permissions.index = slotPropsData.index;
            this.user_permissions.key = slotPropsData.data.key;
            this.user_permissions.id = slotPropsData.data.id;
            this.user_permissions.email = slotPropsData.data.email;
            this.user_permissions.client = slotPropsData.data.client.name;
            this.user_permissions.client_id = slotPropsData.data.client.key;
            this.user_permissions.assigned_sites = slotPropsData.data.assignedSites;
            this.user_permissions.permissionLevel = slotPropsData.data.role.permissionLevel;

            // for addAssetBatchesForDialog() - slotprops data is different when it's fired,
            // so this needs to be stored when the first modal is opened
            this.user_permissions.assigned_batches = slotPropsData.data.assignedBatches;

            let clientSites = db.collection('sites').where('client_id', '==', this.user_permissions.client_id);

            clientSites.get().then((clientSitesSnapshots) => {
                this.clientSites = [];
                clientSitesSnapshots.forEach(doc => {
                    var data = doc.data();
                    var key = doc.id;
                    data = { ...data, key };
                    this.clientSites.push(data);

                });
                this.siteLoading = false;
            });

            if (this.user_permissions.assigned_sites) {
                // if user has assigned sites, push to the checkboxes array
                this.user_permissions.assigned_sites.forEach(index => {
                    this.checkboxes.push(index);
                });
            }

        },
        addAssetBatchesForDialog(slotPropsData) {

            // merge asset batch info with asset batch site name, add to object userBatches
            // only for level 2 users, no data called otherwise for speed
            if (this.user_permissions.permissionLevel <= 2) {

                let userBatches = [];
                userBatches = db.collection('asset_batches');
                let assetBatchSites = [];
                assetBatchSites = db.collection('sites').where('client_id', '==', this.user_permissions.client_id);

                if (this.user_permissions.assigned_batches) {
                    let userRef = db.collection('users');
                    userRef.doc(this.user_permissions.key).get().then((doc) => {
                        this.userData = doc.data();
                    });
                    this.user_permissions.assigned_batches.forEach(index => {
                        userBatches.doc(index).get().then((doc) => {
                            let data = doc.data();

                            if (!this.userData.assignedSites.includes(data.site_id)) {
                                let index = this.user_permissions.assigned_batches.indexOf(doc.id);
                                this.user_permissions.assigned_batches.splice(index, 1);
                            }
                        });
                    });
                }

                // get asset batches and store in a snapshot
                userBatches.get().then((userBatchesSnapshots) => {
                    this.userBatches = [];
                    userBatchesSnapshots.forEach((doc) => {
                        var data = doc.data();
                        var key = doc.id;
                        data = { ...data, key };

                        // if assigned sites array has the sites that the batches are assigned to, get asset batches assigned to this client
                        if (this.user_permissions.assigned_sites.includes(data.site_id)) {
                            assetBatchSites.get().then((assetBatchSitesSnapshots) => {
                                assetBatchSitesSnapshots.forEach((doc) => {
                                    if (doc.id === data.site_id) {
                                        let site_name = doc.data().name;
                                        data = { ...data, site_name };
                                    }
                                });
                                this.userBatches.push(data);
                            });
                        }
                    });
                    this.siteLoading = false;
                });

                if (this.user_permissions.assigned_batches) {
                    // if user has assigned batches, push to the userBatchesCheckboxes array
                    this.user_permissions.assigned_batches.forEach(index => {
                        this.userBatchesCheckboxes.push(index);
                    });
                }
            }
        },
        updateAssetBatchInfo() {

            if (this.user_permissions.assigned_batches) {
                let batchesRef = db.collection('asset_batches');
                let userRef = db.collection('users');
                userRef.doc(this.user_permissions.key).get().then((doc) => {
                    this.userData = doc.data();
                });
                this.user_permissions.assigned_batches.forEach(index => {
                    batchesRef.doc(index).get().then((doc) => {
                        let data = doc.data();

                        if (!this.userData.assignedSites.includes(data.site_id)) {
                            let index = this.user_permissions.assigned_batches.indexOf(doc.id);
                            this.user_permissions.assigned_batches.splice(index, 1);
                        }
                    });
                });
            }
        },
        addCheckboxItemToArray() {
            this.user_permissions.assigned_sites.splice(0, this.user_permissions.assigned_sites.length, ...this.checkboxes);
        },
        addAssetBatchCheckboxItemToArray() {
            this.user_permissions.assigned_batches.splice(0, this.user_permissions.assigned_batches.length, ...this.userBatchesCheckboxes);
        },
        updatePermissionsForDialog() {
            //empties the checkboxes array
            this.checkboxes.length = 0;
            this.userBatches.length = 0;
            this.userData.length = 0;

        },
        resetSiteFilter() {
            this.siteFilters.global = { value: null, matchMode: FilterMatchMode.CONTAINS };
        },
        updateAssetBatchesForDialog() {
            this.userBatchesCheckboxes.length = 0;
        },
        userLevel(level) {
            let index = this.user_levels.map((item) => item.key).indexOf(level);
            if (index >= 0) {
                return this.user_levels[index].name;
            }
            return 'Updating...';
        },
        toggleDeleteDialog(id) {
            this.deleteId = id;
        },
        removeUser(id) {
            // let user = this.users[index];
            let user = this.users.filter(obj => {
                return obj.id == id
            });
            user = user[0];
            axios({
                method: 'post',
                url: process.env.VUE_APP_API_URL + '/user/delete',
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: user
            }).then((response) => {
                let userRef = db.collection('users').doc(response.data.user.email);
                userRef.delete().then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Account deleted', life: 3000 });
                }).catch((error) => {
                    console.log(error)
                });
            }).catch((error) => console.log(error));

        },
        updateUser(id) {
            // let user = this.users[index];
            let user = this.users.filter(obj => {
                return obj.id == id
            });
            user = user[0];
            axios({
                method: 'post',
                url: process.env.VUE_APP_API_URL + '/user/update',
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: user
            }).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Account updated for ' + user.email, life: 3000 });
            }).catch(error => { console.error(error) });
        },
        generate() {
            let charactersArray = this.password.characters.split(',');
            let CharacterSet = '';
            let password = '';

            if (charactersArray.indexOf('a-z') >= 0) {
                CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
            }
            if (charactersArray.indexOf('A-Z') >= 0) {
                CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            }
            if (charactersArray.indexOf('0-9') >= 0) {
                CharacterSet += '0123456789';
            }
            if (charactersArray.indexOf('#') >= 0) {
                CharacterSet += '![]{}()%&*$#^<>~@|';
            }

            for (let i = 0; i < this.password.size; i++) {
                password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
            }
            this.selected.password = password;
        },
        addUser: function () {
            // console.log(this.user);

            if (this.selected.client.length == 0 && this.user.data.role.permissionLevel < 10) {
                this.selected.client = this.user.data.client;
            }
            const userName = this.selected.email.toLowerCase();
            auth.createUserWithEmailAndPassword(userName, this.selected.password).then((response) => {
            db.collection('users').doc(userName).set({
                    active: true,
                    role: this.selected.role,
                    client: this.selected.client,
                    assignedSites: [],
                    assignedBatches: [],
                    id: response.user.uid,
                    email: response.user.email,
                    timestamp: Date.now()
                }).then((user) => {
                    this.selected.email = '';
                    this.selected.role = '';
                    this.selected.client = [];
                    this.visibleRight = false;
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'User created', life: 3000 });
                    this.clearUserLevelOrder();
                });
            }).catch((error) => {
                //TODO: Update UI to reflect the error.
                console.error(error);
            })
            // axios({
            //     method: 'post',
            //     url: process.env.VUE_APP_API_URL + '/user/create',
            //     data: this.selected
            // }).then(() => {
            //     this.selected.email = '';
            //     this.selected.role = '';
            //     this.selected.client = [];
            //     this.visibleRight = false;
            //     this.$toast.add({ severity: 'success', summary: 'Success', detail: 'User created', life: 3000 });
            //     this.clearUserLevelOrder();
            // }).catch(error => { console.error(error) });
        }
    },
}
</script>

<style lang="scss" scoped>
#email {
    text-transform: lowercase;
}

.error {
    color: red;
    display: block;
}

.user_table {
    .p-inplace-display {
        margin-left: -0.5rem !important;
    }
}

.p-dialog-content {
    border-radius: 3px;
}

.site_list_item {
    text-align: left;
    border: 1px solid #e9ecef;
    border-width: 0 0 1px 0;
    padding: 1rem 1rem;

    label {
        padding-left: 2rem;
    }

    &:hover {
        background: #e9ecef;
        color: #495057;
    }
}

.site_list_title {
    text-align: left;
    border: 1px solid #e9ecef;
    border-width: 0 0 1px 0;
    padding: 1rem 1rem;
    background: #f8f9fa;
    color: #2196F3;
    font-weight: 600;
}
</style>
